/* eslint-disable unicorn/filename-case -- TODO rename later */
import { AccessRelation } from "@istari/istari-client";

export enum UserGrantType {
  viewer = "viewer",
  editor = "editor",
  owner = "owner",
  administrator = "administrator",
  executor = "executor",
  upstreamRemoteOwner = "upstreamremoteowner",
}

export function userGrantTypeFromAccessRelation(relation: AccessRelation): UserGrantType {
  switch (relation) {
    case "upstreamremoteowner":
      return UserGrantType.upstreamRemoteOwner;
    default:
      return UserGrantType[relation];
  }
}
